<template>
  <v-row justify="center">
    <v-dialog
      @click:outside="$emit('close')"
      :fullscreen="$vuetify.breakpoint.xs"
      v-model="dialog"
      persistent
      max-width="450px"
    >
      <v-card>
        <v-toolbar dense class="elevation-0 white--text" color="amber darken-1">
          {{ title }}
          <v-spacer></v-spacer>
          <v-btn icon @click="cancel">
            <v-icon dark>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider />
        <v-form ref="form" v-model="valid" @submit.prevent="save">
          <v-card-text class="mt-2 d-flex flex-column">
            <div class="text-h6 mb-4">Sửa điểm</div>
            <div class="d-flex flex-column flex-fill overflow-auto pr-1 item-list">
              <div v-for="st in initialMap" :key="st._id" class="d-flex flex-row align-center mt-2">
                <span
                  class="flex-fill"
                  :class="{
                    'unqualified-student':
                      shouldCheckQualification && !studentQualificationStatus[st._id]
                  }"
                >
                  {{ st.name }}
                  <!-- <v-tooltip v-if="!studentQualificationStatus[st._id]" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" slot="activator">mdi-information</v-icon>
                    </template>
                    Sinh viên không đủ điều kiện tham gia lớp học
                  </v-tooltip> -->
                </span>
                <v-text-field
                  :disabled="shouldCheckQualification && !studentQualificationStatus[st._id]"
                  min="0"
                  max="10"
                  step="0.5"
                  type="number"
                  hide-details="auto"
                  style="min-width: 150px; width: 150px; flex: 0 0 100px"
                  :value="st.mark !== undefined ? st.mark : ''"
                  filled
                  dense
                  @input.native="onChangeMark($event, st._id)"
                  required
                  :rules="[$rules.max(10), $rules.min(0)]"
                ></v-text-field>
              </div>
            </div>
          </v-card-text>
          <v-card-actions class="pr-6 pb-8">
            <v-btn class="px-6" text color="error" @click="clearAll">
              <v-icon> mdi-delete </v-icon>
              Xóa tất cả</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn class="px-6 elevation-0" @click="cancel">Hủy</v-btn>
            <v-btn :loading="isSubmitting" type="submit" class="px-6 elevation-0" color="primary"
              >Lưu</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { round } from 'number-precision'
import { mapActions, mapState, mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  props: {
    dialog: Boolean,
    markId: String
  },
  computed: {
    ...mapState('classDetail', ['marks']),
    ...mapGetters('classDetail', ['classData']),
    ...mapState('auth', ['user']),
    shouldCheckQualification() {
      if (!((this.classData || {}).course_mark_config || {}).requireCondition) {
        return false
      }
      return true
    },

    studentQualificationStatus() {
      if (!((this.classData || {}).course_mark_config || {}).requireCondition) {
        return {}
      }
      if (!this.classData.students) {
        return {}
      }
      return Object.fromEntries(
        this.classData.students.map(i => {
          const qualified = !(this.classData.unqualified_students || []).find(j => j === i.id)
          return [i.id, qualified]
        })
      )
    }
  },
  data: () => ({
    initialMap: [],
    title: '',
    valid: false,
    isSubmitting: false
  }),
  created() {
    this.setUpTitle()
    this.setUpInitialMap()
  },
  methods: {
    ...mapActions('classDetail', ['updateMarks', 'initClass', 'fetchMarks']),
    setUpTitle() {
      if (!this.classData) {
        return
      }
      const courseData = _.get(this.classData, 'course')
      if (!courseData) {
        return
      }
      const markData = _.get(courseData, 'mark')
      if (!markData) {
        return
      }
      const courseMark = markData.find(m => m._id === this.markId)
      if (!courseMark) {
        return
      }
      const courseTitle = courseData.title
      const courseMarkTitle = courseMark.title
      this.title = `${courseTitle} - ${courseMarkTitle}`
    },
    setUpInitialMap() {
      const students = this.classData.students
      const marks = this.marks
      if (!students) {
        return
      }
      if (!marks || !marks.length) {
        this.initialMap = students.map(({ name, _id }) => ({ name, _id, mark: undefined })) || []
        return
      }
      this.initialMap =
        students.map(({ name, _id }) => {
          const mark = marks.find(
            m => m.student._id === _id && (m.courseMark || {}).id === this.markId
          )
          return { name, _id, mark: mark ? mark.value : undefined }
        }) || []
    },
    clearAll() {
      if (!this.initialMap) {
        return
      }
      this.initialMap = this.initialMap.map(({ mark, ...o }) => ({ ...o, mark: undefined }))
    },
    async save() {
      this.valid = this.$refs.form.validate()
      if (!this.valid) {
        this.$alert.error('Lỗi Form! Vui lòng kiểm tra lại')
        return
      }
      try {
        this.isSubmitting = true

        await this.updateMarks({
          id: this.classData._id,
          data: this.initialMap.map(({ _id, mark: value }) => {
            let valueNum
            if (value === undefined || value === null) {
              valueNum = value
            } else if (typeof value === 'string') {
              valueNum = parseFloat(value)
              if (isNaN(valueNum)) {
                valueNum = null
              } else {
                valueNum = round(valueNum, 1)
              }
            } else {
              valueNum = value
            }
            return {
              student: _id,
              value: valueNum,
              class: this.classData.id,
              course: _.get(this.classData, 'course.id'),
              course_mark_config: _.get(this.classData, 'course_mark_config.id'),
              courseMark: this.markId,
              // major: _.get(this.classData, 'major.id'),
              // department: _.get(this.classData, 'department.id'),
              status: 'learning',
              ...(['education_manager', 'super_admin'].includes(this.user.role.type)
                ? { lastUpdatedBy_user: this.user.id, lastUpdatedBy_teacher: null }
                : { lastUpdatedBy_teacher: this.user.id, lastUpdatedBy_user: null })
            }
          })
        })
        this.$alert.success('Lưu điểm thành công')
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra!')
        console.error(error)
        this.fetchMarks({ class: this.classData._id })
      } finally {
        await this.initClass({ id: this.classData.id })
        this.isSubmitting = false
        this.$emit('close')
      }
      // const missingSomeStudents = this.initialMap.filter(
      //   ({ mark }) => mark === undefined || mark === null
      // ).length
      // const next = async () => {
      //   try {
      //     this.isSubmitting = true
      //     await this.updateMarks({
      //       id: this.classData._id,
      //       data: this.initialMap.map(({ _id, mark: value }) => {
      //         let valueNum
      //         if (value === undefined || value === null) {
      //           valueNum = value
      //         } else if (typeof value === 'string') {
      //           valueNum = parseFloat(value)
      //           if (isNaN(valueNum)) {
      //             valueNum = null
      //           } else {
      //             valueNum = round(valueNum, 2)
      //           }
      //         } else {
      //           valueNum = value
      //         }
      //         return {
      //           student: _id,
      //           value: valueNum,
      //           class: this.classData.id,
      //           course: _.get(this.classData, 'course.id'),
      //           courseMark: this.markId,
      //           // major: _.get(this.classData, 'major.id'),
      //           // department: _.get(this.classData, 'department.id'),
      //           status: 'learning',
      //           ...(this.user.role.type === 'manager'
      //             ? { lastUpdatedBy_user: this.user.id, lastUpdatedBy_teacher: null }
      //             : { lastUpdatedBy_teacher: this.user.id, lastUpdatedBy_user: null })
      //         }
      //       })
      //     })
      //     this.$alert.success('Lưu điểm thành công')
      //   } catch (error) {
      //     this.$alert.error('Có lỗi xảy ra!')
      //     console.error(error)
      //   } finally {
      //     await this.initClass({ id: this.classData._id })
      //     this.isSubmitting = false
      //     this.$emit('close')
      //   }
      // }

      // await next()
    },
    cancel() {
      this.$emit('close')
    },
    onChangeMark($e, studentId) {
      const newMap = this.initialMap.map(i =>
        i._id === studentId ? { ...i, mark: $e.target.value } : i
      )
      this.initialMap = newMap
    }
  },
  watch: {
    markId() {
      this.setUpTitle()
      this.setUpInitialMap()
    }
  }
}
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/styles.sass';

.unqualified-student {
  text-decoration: line-through;
}
.item-list {
  max-height: calc(100vh - 194px);
}
@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .item-list {
    max-height: 60vh;
  }
}
</style>
